import axios from 'axios'
import store from '../store'

const BASE_URL = process.env.VUE_APP_API_URL || ''

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 自动附带 token
api.interceptors.request.use(
  config => {
    const token = store.state.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器 - 错误处理
api.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        store.dispatch('logout')
        window.location.href = '/login'
      } else if (status === 403) {
        console.error('权限不足')
      } else if (status === 404) {
        console.error('资源不存在')
      }
    }
    return Promise.reject(error)
  }
)

// ========================================
// 前端公开接口
// ========================================

export const frontApi = {
  // 获取文章列表
  getArticles(params) {
    return api.get('/api/articles', { params })
  },
  // 获取文章详情
  getArticle(slug) {
    return api.get(`/api/articles/${slug}`)
  },
  // 获取分类列表
  getCategories() {
    return api.get('/api/categories')
  },
  // 获取标签列表
  getTags() {
    return api.get('/api/tags')
  },
  // 获取博主信息
  getAbout() {
    return api.get('/api/about')
  },
  // 获取归档
  getArchive() {
    return api.get('/api/archive')
  },
  // 登录
  login(data) {
    return api.post('/api/login', data)
  },
  // 记录浏览行为
  recordView(data) {
    return api.post('/api/view-record', data)
  },
  // 获取项目列表
  getProjects() {
    return api.get('/api/projects')
  }
}

// ========================================
// 管理后台接口
// ========================================

export const adminApi = {
  // Dashboard
  getDashboard() {
    return api.get('/admin/api/dashboard')
  },
  // 文章管理
  getArticles(params) {
    return api.get('/admin/api/articles', { params })
  },
  createArticle(data) {
    return api.post('/admin/api/articles', data)
  },
  updateArticle(id, data) {
    return api.put(`/admin/api/articles/${id}`, data)
  },
  deleteArticle(id) {
    return api.delete(`/admin/api/articles/${id}`)
  },
  // 分类管理
  createCategory(data) {
    return api.post('/admin/api/categories', data)
  },
  updateCategory(id, data) {
    return api.put(`/admin/api/categories/${id}`, data)
  },
  deleteCategory(id) {
    return api.delete(`/admin/api/categories/${id}`)
  },
  // 标签管理
  createTag(data) {
    return api.post('/admin/api/tags', data)
  },
  updateTag(id, data) {
    return api.put(`/admin/api/tags/${id}`, data)
  },
  deleteTag(id) {
    return api.delete(`/admin/api/tags/${id}`)
  },
  // 用户管理
  getUsers() {
    return api.get('/admin/api/users')
  },
  updateUser(id, data) {
    return api.put(`/admin/api/users/${id}`, data)
  },
  // 初始化管理员
  initAdmin(data) {
    return api.post('/admin/api/init-admin', data)
  },
  // 浏览记录
  getViewRecords(params) {
    return api.get('/admin/api/view-records', { params })
  },
  getViewStats() {
    return api.get('/admin/api/view-stats')
  },
  deleteViewRecord(id) {
    return api.delete(`/admin/api/view-records/${id}`)
  },
  clearViewRecords() {
    return api.post('/admin/api/view-records/clear')
  },
  // 项目管理
  getProjects(params) {
    return api.get('/admin/api/projects', { params })
  },
  createProject(data) {
    return api.post('/admin/api/projects', data)
  },
  updateProject(id, data) {
    return api.put(`/admin/api/projects/${id}`, data)
  },
  deleteProject(id) {
    return api.delete(`/admin/api/projects/${id}`)
  }
}

export default api
